import { render, staticRenderFns } from "./RefundComponent.vue?vue&type=template&id=3465f7ec&"
import script from "./RefundComponent.vue?vue&type=script&lang=js&"
export * from "./RefundComponent.vue?vue&type=script&lang=js&"
import style0 from "./RefundComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports